<template>
  <b-row class="justify-content-center" no-gutters>
    <b-col cols="12" sm="8" md="6" lg="4" xl="4" class="fit-to-screen bg-white">
      <div class="w-100 bg-white" style="min-height: 100vh;">
        <div class="w-100 p-5" v-if="error != ''">
          <ErrorMessage :message="error" />
        </div>
        <template v-else>
          <template v-if="is_load">
            <div class="w-100 mb-4" v-if="is_load">
              <b-skeleton-img no-aspect height="300px"></b-skeleton-img>
            </div>
            <div class="ga-container">
              <b-skeleton width="70%" height="27px" class="mb-2"></b-skeleton>
              <b-skeleton width="100%" height="21px" class="mb-1"></b-skeleton>
              <b-skeleton width="40%" height="21px" class="mb-1"></b-skeleton>
              <div class="w-100 bg-white py-3 border-t-form mt-3">
                <b-skeleton width="100%" height="21px" class="mb-1"></b-skeleton>
                <b-skeleton width="100%" height="21px" class="mb-1"></b-skeleton>
                <b-skeleton width="40%" height="21px" class="mb-1"></b-skeleton>
              </div>
            </div>
          </template>
          <template v-else>
            <!-- NAVBAR  -->
            <div class="w-100 position-absolute py-3 z-index-1040" style="top:0;" v-if="general_data.slider_image.length > 0">
              <div class="ga-container">
                <div class="row">
                  <div class="col-12 align-self-center text-right">
                    <div class="pos-navbar-icon" @click="goToPage('PosHome')" :class="scroll_p < 90 ? 'active' : ''">
                      <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_581_18)">
                          <path
                            d="M0.0294189 8.00744C0.0294189 8.27112 0.145437 8.5137 0.356381 8.7141L7.35969 15.7069C7.57064 15.9073 7.79213 16.0022 8.04526 16.0022C8.56207 16.0022 8.97341 15.6225 8.97341 15.0951C8.97341 14.842 8.87848 14.5889 8.70973 14.4306L6.34717 12.0259L2.1705 8.21839L1.949 8.7352L5.34519 8.94614H18.6874C19.2358 8.94614 19.6155 8.5559 19.6155 8.00744C19.6155 7.45899 19.2358 7.06874 18.6874 7.06874H5.34519L1.949 7.27969L2.1705 7.80705L6.34717 3.98898L8.70973 1.58422C8.87848 1.41546 8.97341 1.17288 8.97341 0.919749C8.97341 0.392393 8.56207 0.0126953 8.04526 0.0126953C7.79213 0.0126953 7.57064 0.0970726 7.3386 0.32911L0.356381 7.30079C0.145437 7.50118 0.0294189 7.74376 0.0294189 8.00744Z"
                            fill="black" fill-opacity="0.85" />
                        </g>
                        <defs>
                          <clipPath id="clip0_581_18">
                            <rect width="19.5861" height="16" fill="white" transform="translate(0.0294189 0.0126953)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-100" v-else>
              <div class="w-100 fixed-top bg-white border-form py-3 z-index-1041">
                <div class="ga-container py-2">
                  <div class="d-flex">
                    <div class="lh-1 align-self-center mr-3">
                      <svg @click="goToPage('PosHome')" class="lh-1 cursor-pointer" width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_581_18)">
                          <path
                            d="M0.0294189 8.00744C0.0294189 8.27112 0.145437 8.5137 0.356381 8.7141L7.35969 15.7069C7.57064 15.9073 7.79213 16.0022 8.04526 16.0022C8.56207 16.0022 8.97341 15.6225 8.97341 15.0951C8.97341 14.842 8.87848 14.5889 8.70973 14.4306L6.34717 12.0259L2.1705 8.21839L1.949 8.7352L5.34519 8.94614H18.6874C19.2358 8.94614 19.6155 8.5559 19.6155 8.00744C19.6155 7.45899 19.2358 7.06874 18.6874 7.06874H5.34519L1.949 7.27969L2.1705 7.80705L6.34717 3.98898L8.70973 1.58422C8.87848 1.41546 8.97341 1.17288 8.97341 0.919749C8.97341 0.392393 8.56207 0.0126953 8.04526 0.0126953C7.79213 0.0126953 7.57064 0.0970726 7.3386 0.32911L0.356381 7.30079C0.145437 7.50118 0.0294189 7.74376 0.0294189 8.00744Z"
                            fill="black" fill-opacity="0.85" />
                        </g>
                        <defs>
                          <clipPath id="clip0_581_18">
                            <rect width="19.5861" height="16" fill="white" transform="translate(0.0294189 0.0126953)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div class="lh-1 align-self-center">
                      <p class="body-1-4 mb-0">Detail</p>
                    </div>
                  </div>
                </div>
              </div>
              <block :height="70" />
            </div>
            
            <!-- SLIDER -->
            <div class="w-100 position-relative" v-if="general_data.slider_image.length > 0">
              <template v-if="general_data.slider_image.length > 1">
                <flickity ref="main_slider" :options="$basic_slider_option" class="spa-product">
                  <div class="carousel-cell w-100" :id="slider_merchant.id"
                    v-for="(slider_merchant,index) in  general_data.slider_image">
                    <div class="w-100" style="height: 300px;">
                      <img @click="setActiveImage(index)" :src="slider_merchant.image_url"
                        class="img-fit cursor-zoom" :alt="general_data.name">
                    </div>
                  </div>
                </flickity>
                <div class="concierge-slider-btn right" @click="clickButtonSlider('next')">
                  <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="16.5" cy="16.5" r="16" fill="white" stroke="#D9D9D9" />
                    <path
                      d="M20 16.5202C20 16.3324 19.9249 16.1446 19.7821 16.0169L13.8253 10.2028C13.6976 10.0751 13.5324 10 13.3446 10C12.954 10 12.6535 10.293 12.6535 10.6836C12.6535 10.8714 12.7286 11.0441 12.8488 11.1719L18.7305 16.9258V16.1221L12.8488 21.8761C12.7286 21.9962 12.6535 22.169 12.6535 22.3643C12.6535 22.7549 12.954 23.0479 13.3446 23.0479C13.5324 23.0479 13.6976 22.9728 13.8329 22.8451L19.7821 17.031C19.9249 16.8883 20 16.7155 20 16.5202Z"
                      fill="black" fill-opacity="0.85" />
                  </svg>
                </div>
                <div class="concierge-slider-btn left" @click="clickButtonSlider('previous')">
                  <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="16.5" cy="16.5" r="16" fill="white" stroke="#D9D9D9" />
                    <path
                      d="M12.6535 16.5277C12.6535 16.7155 12.7286 16.9033 12.8714 17.031L18.8282 22.8451C18.9559 22.9728 19.1211 23.0479 19.3089 23.0479C19.6995 23.0479 20 22.7549 20 22.3643C20 22.1765 19.9249 22.0038 19.8047 21.876L13.923 16.1221V16.9258L19.8047 11.1718C19.9249 11.0516 20 10.8789 20 10.6836C20 10.293 19.6995 10 19.3089 10C19.1211 10 18.9559 10.0751 18.8207 10.2028L12.8714 16.0169C12.7286 16.1596 12.6535 16.3324 12.6535 16.5277Z"
                      fill="black" fill-opacity="0.85" />
                  </svg>
                </div>
              </template>
              <template v-else>
                <div class="w-100" style="height:300px">
                  <img @click="setActiveImage(0)" :src="general_data.slider_image[0].image_url" class="img-fit" :alt="general_data.name">
                </div>
              </template>
              <CoolLightBox 
                :items="general_data.slider_image" 
                srcName="image_url" 
                :index="active_image"
                closeOnClickOutsideMobile
                @close="active_image = null">
              </CoolLightBox>
            </div>
            
            <div class="ga-container mt-3">
              <div class="row">
                <div class="col-10">
                  <p class="mb-0 heading-6-1">{{ general_data.name }}</p>
                  <div class="no-ws w-100 d-flex mt-1 mb-2" v-if="!general_data.use_daily_operational_hour">
                    <p class="mb-0 body-2-1 align-self-center text-green">Everyday</p>
                    <svg class="align-self-center mx-3" width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_395_13)">
                        <path
                          d="M3 6C4.64119 6 6 4.63825 6 3C6 1.35883 4.63825 0 2.99706 0C1.35883 0 0 1.35883 0 3C0 4.63825 1.36177 6 3 6Z"
                          fill="#222222" fill-opacity="0.85" />
                      </g>
                      <defs>
                        <clipPath id="clip0_395_13">
                          <rect width="6" height="6.00296" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <p class="mb-0 body-2-1 align-self-center">{{ $customFormatDateTime(general_data.time_start,'HH:mm:ss','HH:mm') }} - {{ $customFormatDateTime(general_data.time_end,'HH:mm:ss','HH:mm') }}</p>
                  </div>
                  <p class="mb-1 body-2-2" v-if="$isNotEmpty(general_data.location)">{{ general_data.location }}</p>
                </div>
                <div class="col-2 text-right" v-if="$isNotEmpty(general_data.star)">
                  <div class="mb-0 d-flex">
                    <svg class="align-self-center mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M10.4525 8.35339C10.3014 8.49981 10.232 8.71156 10.2664 8.91922L10.785 11.7892C10.8287 12.0325 10.726 12.2786 10.5225 12.4192C10.323 12.5651 10.0575 12.5826 9.83996 12.4659L7.25637 11.1184C7.16654 11.0706 7.06679 11.0449 6.96471 11.042H6.80662C6.75179 11.0501 6.69812 11.0676 6.64912 11.0945L4.06496 12.4484C3.93721 12.5126 3.79254 12.5353 3.65079 12.5126C3.30546 12.4472 3.07504 12.1182 3.13162 11.7711L3.65079 8.90114C3.68521 8.69172 3.61579 8.47881 3.46471 8.33006L1.35829 6.28839C1.18212 6.11747 1.12087 5.86081 1.20137 5.62922C1.27954 5.39822 1.47904 5.22964 1.71996 5.19172L4.61912 4.77114C4.83962 4.74839 5.03329 4.61422 5.13246 4.41589L6.40996 1.79672C6.44029 1.73839 6.47937 1.68472 6.52662 1.63922L6.57912 1.59839C6.60654 1.56806 6.63804 1.54297 6.67304 1.52256L6.73662 1.49922L6.83579 1.45839H7.08137C7.30071 1.48114 7.49379 1.61239 7.59471 1.80839L8.88912 4.41589C8.98246 4.60664 9.16387 4.73906 9.37329 4.77114L12.2725 5.19172C12.5175 5.22672 12.7222 5.39589 12.8033 5.62922C12.8797 5.86314 12.8138 6.11981 12.6341 6.28839L10.4525 8.35339Z"
                        fill="#F68611" />
                    </svg>
                    <p class="mb-0 body-3-1 align-self-center">{{ general_data.star }}</p>
                  </div>
                </div>
                <div class="col-12">
                  <div class="w-100 border-t-form-2-dashed my-3"></div>
                </div>
                <div class="col-12">
                  <p class="mb-0 body-2-2">{{ general_data.description }}</p>
                </div>
              </div>
            </div>
        
            <template v-if="general_data.use_daily_operational_hour">
              <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>
              <div class="ga-container pb-5">
                <p class="mb-3 body-1-4">Opening hour</p>
                <div class="w-100">
                  <div class="d-flex mb-4" v-for="day in general_data.daily_hour">
                    <div class="align-self-center mr-3">
                      <svg v-if="day.is_open" width="50" height="49" viewBox="0 0 50 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.1376 42.3767H32.8381C36.9233 42.3767 38.9562 40.344 38.9562 36.3173V12.4511C38.9562 8.42455 36.9233 6.39172 32.8381 6.39172H6.1376C2.05238 6.39172 0 8.405 0 12.4511V36.3173C0 40.3635 2.05238 42.3767 6.1376 42.3767ZM5.84441 39.2298C4.10477 39.2298 3.14699 38.3112 3.14699 36.4933V18.0609C3.14699 16.2627 4.10477 15.3245 5.84441 15.3245H33.0921C34.8318 15.3245 35.8093 16.2627 35.8093 18.0609V36.4933C35.8093 38.3112 34.8318 39.2298 33.0921 39.2298H5.84441Z"
                          fill="black" fill-opacity="0.85" />
                        <path
                          d="M15.6763 22.3416H16.8295C17.5137 22.3416 17.7287 22.1461 17.7287 21.4621V20.3089C17.7287 19.6247 17.5137 19.4097 16.8295 19.4097H15.6763C14.9922 19.4097 14.7576 19.6247 14.7576 20.3089V21.4621C14.7576 22.1461 14.9922 22.3416 15.6763 22.3416ZM22.1658 22.3416H23.3191C24.0031 22.3416 24.2376 22.1461 24.2376 21.4621V20.3089C24.2376 19.6247 24.0031 19.4097 23.3191 19.4097H22.1658C21.4816 19.4097 21.2471 19.6247 21.2471 20.3089V21.4621C21.2471 22.1461 21.4816 22.3416 22.1658 22.3416ZM28.6552 22.3416H29.8085C30.4925 22.3416 30.7272 22.1461 30.7272 21.4621V20.3089C30.7272 19.6247 30.4925 19.4097 29.8085 19.4097H28.6552C27.971 19.4097 27.756 19.6247 27.756 20.3089V21.4621C27.756 22.1461 27.971 22.3416 28.6552 22.3416ZM9.18689 28.7334H10.3206C11.0243 28.7334 11.2393 28.5379 11.2393 27.8537V26.7005C11.2393 26.0165 11.0243 25.821 10.3206 25.821H9.18689C8.48322 25.821 8.2682 26.0165 8.2682 26.7005V27.8537C8.2682 28.5379 8.48322 28.7334 9.18689 28.7334ZM15.6763 28.7334H16.8295C17.5137 28.7334 17.7287 28.5379 17.7287 27.8537V26.7005C17.7287 26.0165 17.5137 25.821 16.8295 25.821H15.6763C14.9922 25.821 14.7576 26.0165 14.7576 26.7005V27.8537C14.7576 28.5379 14.9922 28.7334 15.6763 28.7334ZM22.1658 28.7334H23.3191C24.0031 28.7334 24.2376 28.5379 24.2376 27.8537V26.7005C24.2376 26.0165 24.0031 25.821 23.3191 25.821H22.1658C21.4816 25.821 21.2471 26.0165 21.2471 26.7005V27.8537C21.2471 28.5379 21.4816 28.7334 22.1658 28.7334ZM9.18689 35.1446H10.3206C11.0243 35.1446 11.2393 34.9296 11.2393 34.2454V33.0922C11.2393 32.4081 11.0243 32.2126 10.3206 32.2126H9.18689C8.48322 32.2126 8.2682 32.4081 8.2682 33.0922V34.2454C8.2682 34.9296 8.48322 35.1446 9.18689 35.1446ZM15.6763 35.1446H16.8295C17.5137 35.1446 17.7287 34.9296 17.7287 34.2454V33.0922C17.7287 32.4081 17.5137 32.2126 16.8295 32.2126H15.6763C14.9922 32.2126 14.7576 32.4081 14.7576 33.0922V34.2454C14.7576 34.9296 14.9922 35.1446 15.6763 35.1446ZM22.1658 35.1446H23.3191C24.0031 35.1446 24.2376 34.9296 24.2376 34.2454V33.0922C24.2376 32.4081 24.0031 32.2126 23.3191 32.2126H22.1658C21.4816 32.2126 21.2471 32.4081 21.2471 33.0922V34.2454C21.2471 34.9296 21.4816 35.1446 22.1658 35.1446Z"
                          fill="black" fill-opacity="0.85" />
                        <path
                          d="M37.412 48.7293C44.2729 48.7293 50 43.0022 50 36.1219C50 29.2025 44.3314 23.5145 37.412 23.5145C30.4925 23.5145 24.8045 29.222 24.8045 36.1219C24.8045 43.0609 30.473 48.7293 37.412 48.7293Z"
                          fill="white" />
                        <path
                          d="M37.412 46.0516C42.7872 46.0516 47.3416 41.5559 47.3416 36.1219C47.3416 30.6684 42.8459 26.1923 37.412 26.1923C31.9586 26.1923 27.4824 30.688 27.4824 36.1219C27.4824 41.595 31.9586 46.0516 37.412 46.0516Z"
                          class="fill-success" />
                        <path
                          d="M36.2196 41.4777C35.8873 41.4777 35.4963 41.3409 35.2423 41.0672L31.9389 37.4315C31.7044 37.1775 31.6066 36.8255 31.6066 36.552C31.6066 35.8483 32.1539 35.3205 32.8381 35.3205C33.2486 35.3205 33.5613 35.516 33.7568 35.731L36.161 38.3307L40.9304 31.7239C41.1649 31.4111 41.5167 31.1766 41.9664 31.1766C42.6114 31.1766 43.1977 31.7044 43.1977 32.3886C43.1977 32.6036 43.0999 32.8771 42.9241 33.1313L37.2555 41.0085C37.0405 41.3017 36.6497 41.4777 36.2196 41.4777Z"
                          fill="white" />
                      </svg>
                      <svg v-else width="50" height="49" viewBox="0 0 50 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.1376 42.3767H32.8381C36.9233 42.3767 38.9562 40.344 38.9562 36.3173V12.4511C38.9562 8.42454 36.9233 6.39171 32.8381 6.39171H6.1376C2.05238 6.39171 0 8.40499 0 12.4511V36.3173C0 40.3635 2.05238 42.3767 6.1376 42.3767ZM5.84441 39.2298C4.10477 39.2298 3.14699 38.3112 3.14699 36.4933V18.0609C3.14699 16.2627 4.10477 15.3245 5.84441 15.3245H33.0921C34.8318 15.3245 35.8093 16.2627 35.8093 18.0609V36.4933C35.8093 38.3112 34.8318 39.2298 33.0921 39.2298H5.84441Z"
                          fill="black" fill-opacity="0.4" />
                        <path
                          d="M15.6763 22.3416H16.8295C17.5137 22.3416 17.7287 22.1461 17.7287 21.4621V20.3088C17.7287 19.6246 17.5137 19.4096 16.8295 19.4096H15.6763C14.9922 19.4096 14.7576 19.6246 14.7576 20.3088V21.4621C14.7576 22.1461 14.9922 22.3416 15.6763 22.3416ZM22.1658 22.3416H23.319C24.0031 22.3416 24.2376 22.1461 24.2376 21.4621V20.3088C24.2376 19.6246 24.0031 19.4096 23.319 19.4096H22.1658C21.4816 19.4096 21.2471 19.6246 21.2471 20.3088V21.4621C21.2471 22.1461 21.4816 22.3416 22.1658 22.3416ZM28.6552 22.3416H29.8084C30.4925 22.3416 30.7271 22.1461 30.7271 21.4621V20.3088C30.7271 19.6246 30.4925 19.4096 29.8084 19.4096H28.6552C27.971 19.4096 27.756 19.6246 27.756 20.3088V21.4621C27.756 22.1461 27.971 22.3416 28.6552 22.3416ZM9.18686 28.7334H10.3206C11.0242 28.7334 11.2392 28.5379 11.2392 27.8537V26.7005C11.2392 26.0165 11.0242 25.821 10.3206 25.821H9.18686C8.48319 25.821 8.26817 26.0165 8.26817 26.7005V27.8537C8.26817 28.5379 8.48319 28.7334 9.18686 28.7334ZM15.6763 28.7334H16.8295C17.5137 28.7334 17.7287 28.5379 17.7287 27.8537V26.7005C17.7287 26.0165 17.5137 25.821 16.8295 25.821H15.6763C14.9922 25.821 14.7576 26.0165 14.7576 26.7005V27.8537C14.7576 28.5379 14.9922 28.7334 15.6763 28.7334ZM22.1658 28.7334H23.319C24.0031 28.7334 24.2376 28.5379 24.2376 27.8537V26.7005C24.2376 26.0165 24.0031 25.821 23.319 25.821H22.1658C21.4816 25.821 21.2471 26.0165 21.2471 26.7005V27.8537C21.2471 28.5379 21.4816 28.7334 22.1658 28.7334ZM9.18686 35.1446H10.3206C11.0242 35.1446 11.2392 34.9296 11.2392 34.2454V33.0922C11.2392 32.4081 11.0242 32.2126 10.3206 32.2126H9.18686C8.48319 32.2126 8.26817 32.4081 8.26817 33.0922V34.2454C8.26817 34.9296 8.48319 35.1446 9.18686 35.1446ZM15.6763 35.1446H16.8295C17.5137 35.1446 17.7287 34.9296 17.7287 34.2454V33.0922C17.7287 32.4081 17.5137 32.2126 16.8295 32.2126H15.6763C14.9922 32.2126 14.7576 32.4081 14.7576 33.0922V34.2454C14.7576 34.9296 14.9922 35.1446 15.6763 35.1446ZM22.1658 35.1446H23.319C24.0031 35.1446 24.2376 34.9296 24.2376 34.2454V33.0922C24.2376 32.4081 24.0031 32.2126 23.319 32.2126H22.1658C21.4816 32.2126 21.2471 32.4081 21.2471 33.0922V34.2454C21.2471 34.9296 21.4816 35.1446 22.1658 35.1446Z"
                          fill="black" fill-opacity="0.4" />
                        <path
                          d="M37.412 48.7293C44.2729 48.7293 50 43.0022 50 36.1218C50 29.2024 44.3314 23.5145 37.412 23.5145C30.4924 23.5145 24.8045 29.222 24.8045 36.1218C24.8045 43.0609 30.4729 48.7293 37.412 48.7293Z"
                          fill="white" />
                        <path
                          d="M37.412 46.0516C42.7872 46.0516 47.3416 41.5559 47.3416 36.1219C47.3416 30.6684 42.8459 26.1923 37.412 26.1923C31.9586 26.1923 27.4825 30.688 27.4825 36.1219C27.4825 41.595 31.9586 46.0516 37.412 46.0516Z"
                          class="fill-danger" />
                        <path
                          d="M32.3886 37.3143C31.7239 37.3143 31.1766 36.7473 31.1766 36.1218C31.1766 35.4963 31.7239 34.9296 32.3886 34.9296H42.4354C43.0804 34.9296 43.6277 35.4963 43.6277 36.1218C43.6277 36.7473 43.0804 37.3143 42.4354 37.3143H32.3886Z"
                          fill="white" />
                      </svg>
                    </div>
                    <div class="align-self-center">
                      <p class="mb-0 body-1-4">{{ day.title }}</p>
                      <p class="mb-0 body-3" v-if="day.is_open">{{ $customFormatDateTime(day.time_start,'HH:mm:ss','HH:mm') }} - {{ $customFormatDateTime(day.time_end,'HH:mm:ss','HH:mm') }}</p>
                      <p class="mb-0 body-3" v-else>Closed</p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </template>
      </div>
    </b-col>
  </b-row>
</template>

<script>
  import {
    mapGetters
  } from 'vuex';
  import {
    get
  } from '@/services/index.js'
  import CoolLightBox from 'vue-cool-lightbox'
  import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

  export default {
    components:{
      CoolLightBox
    },
    metaInfo() {
      return {
        title: this.page_title,
        titleTemplate: this.getMetaTitleTemplate
      }
    },
    data() {
      return {
        is_load: true,
        error: '',
        general_data: {},
        active_image: null,
        scroll_p: 0,
      }
    },
    computed:{
      ...mapGetters(['getMerchant','getOutletTrxPromoCode','setTrxOutletPromoCode','getMetaTitleTemplate']),
      pos_code() {
        return this.$route.params.pos_code
      },
      page_title(){
        if(this.general_data.id) return this.general_data.name
        return ''
      }
    },
    mounted() {
      this.loadFirstData()
      window.addEventListener('scroll', this.updateScroll);
    },
    methods:{
      updateScroll() {
        this.scroll_p = window.scrollY
      },
      loadFirstData() {
        this.is_load = true
        this.error = ''
        Promise.all([
          this.loadGeneralData(),
        ]).catch(err => this.error = err).finally(() => this.is_load = false)
      },
      loadGeneralData() {
        return new Promise((success, fail) => {
          this.general_data = {}
          get("CORE_HOTEL", `merchant-pos/${this.pos_code}/general`, {
            merchant_id: this.getMerchant.id
          }).then(response => {
            let res = response.data
            if (res.success) {
              this.general_data = res.data
              this.$validatePage('CONCIERGE',this.general_data).then(()=>{
                if(res.data.use_daily_operational_hour) this.setupDailyOpeningHour()
                success()
              }).catch(()=>fail())
            } else {
              fail(res.message)
            }
          })
        })
      },
      setActiveImage(index){
        this.active_image = index
      },
      clickButtonSlider(type){
        if(type == 'next') this.$refs.main_slider.next()
        else this.$refs.main_slider.previous()
      },
      setupDailyOpeningHour(){
        let days = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday']
        this.general_data.daily_hour = []
        days.forEach(day => {
          let key = {
            open: `sale_${day}`,
            time_start: `time_start_${day}`,
            time_end: `time_end_${day}`
          }          
          let new_data = {
            title: this.$capitalize(day),
            is_open: this.general_data[key.open],
            time_start: this.general_data[key.time_start],
            time_end: this.general_data[key.time_end]
          }

          this.general_data.daily_hour.push(new_data)
        });
      },
      goToPage(page) {
        let route = {
          name: page,
          params: {
            merchant_code: this.getMerchant.code,
            pos_code: this.pos_code
          }
        }
        this.$router.push(route)
      },
    }
  }
</script>
<style>
  .pos-navbar-icon{
    border-radius: 100%;
    height: 0px;
    width: 40px;
    text-align: center;
    display: grid; 
    place-items: center; 
    background-color: #fff;
    max-height: 0px;
    transition: max-height 0.3s;
    overflow: hidden;
  }
  .pos-navbar-icon.active {
    height: 40px;
    max-height: 50px;
    border: 1px solid #ccc;
  }
</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/DetailPos.vue